var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"maskCountry"},[_c('CommonLang',{attrs:{"overlay":false},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }